import React, { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Article } from '../../../../../../types/items';
import {
  getArticleDocumentPagesRequest,
  setCurrentArticleDocumentPage, setCurrentDocumentPageIndexMediaViewer,
} from '../../../../../../store/modules/articles/actions';
import styles from './styles';
import { ButtonOption } from '../../../../../../components/button/ButtonGroup';
import { selectCurrentDocumentPage, selectDocumentPageList } from '../../../../../../store/modules/articles/selectors';
import ButtonGroupSelect from '../../../../../../components/button/ButtonGroupSelect';

type Props = {
  media: Article;
  className?: string;
};

const PageSelect = ({ media, className = '' }: Props) => {
  const classes = styles();
  const dispatch = useDispatch();
  const pages = useSelector(selectDocumentPageList);
  const currentPage = useSelector(selectCurrentDocumentPage);
  const isProcessingMedia = media.ref.document?.ref?.is_processing;

  useEffect(() => {
    if (media.ref.document?.media_type_id === 4 && !isProcessingMedia) {
      dispatch(getArticleDocumentPagesRequest(media.document_id));
    }
  }, [dispatch, media, isProcessingMedia]);


  const setCurrentDocumentPage = useCallback((documentPage) => {
    dispatch(setCurrentArticleDocumentPage(documentPage));
    dispatch(setCurrentDocumentPageIndexMediaViewer(documentPage.id));
  }, [dispatch]);

  const buttonPages: ButtonOption[] = (currentPage !== null && pages) ? pages.map((page): ButtonOption => ({
    title: `Page ${page.id}`,
    disabled: false,
    onClick: () => setCurrentDocumentPage(page),
  })) : [];

  return (
    <ButtonGroupSelect
      buttons={buttonPages}
      className={`${classes.groupAction} ${className}`}
      color="default"
      variant="text"
      overlay={false}
      currentIndex={(currentPage?.id) ? currentPage.id - 1 : 0}
    />
  );
};

export default PageSelect;
